<manage-wrapper
  *ngIf="!!entity"
  [canEditMain]="true"
  [entityTitle]="entity.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="false"
  [deleteTitle]="'Delete this Attendee Template'"
  [type]="'attendee'"
  [titlePlaceholder]="'Attendee template name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Clipboard Attendee Details'"
  [canDuplicate]="false"
  [hideLabels]="true"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
>
  <ng-container *ngIf="!selectedTab || selectedTab?.id === 'details'">

    <div class="uploaders-holder">
      <image-uploader 
        [id]="entity.id"
        (newUrls)="changeImage($event, 'photo')"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="entity.photoUrl" 
        [photoUrl]="entity.fullPhotoUrl"
        [eventId]="data.accountId"
        [isTemplate]="true"
        [type]="'attendee'" 
        [subtype]="'photo'" 
        [placeholder]="'Add photo'" 
        [uploadText]="'UPLOAD PHOTO'"
        [saveName]="entity.name"
      ></image-uploader>
    </div>

    <h3 class="description-title">Line 1 (e.g. job title)</h3>
    <joi-input class="description" [italicPlaceholder]="true" [(model)]="entity.line1" [placeholder]="'Click to add line 1...'" (joiChange)="saveEntity()"></joi-input>

    <h3 class="description-title">Line 2 (e.g. company)</h3>
    <joi-input class="description" [italicPlaceholder]="true" [(model)]="entity.line2" [placeholder]="'Click to add line 2...'" (joiChange)="saveEntity()"></joi-input>

    <manage-social [links]="entity?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="entity"
      [entityName]="'Attendee'"
      [numberProp]="'phone'"
      [emailProp]="'email'"
      [readOnly]="false"
      (contactDetailsChanged)="saveEntity()"
    ></manage-contact-details>
  </ng-container>
</manage-wrapper> 